import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vm',
  templateUrl: './vm.component.html',
  styleUrls: ['./vm.component.css']
})
export class VmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
